export const filterByUnique = (
	value: string | number,
	index: number,
	self: any[]
) => {
	return self.indexOf(value) === index;
};
